import React, { useState } from "react";
import "../../css/pages/contentShow.scss";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import SmallContentDisplay from "./SmallContentDisplay";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import Button from "@mui/material/Button";
import Sidebar from "./Sidebar";
import { NavLink, useNavigate } from "react-router-dom";
import { Skeleton } from "@mui/material";
import { withErrorBoundary } from "react-error-boundary";
import ErrorFallback from "../../helpers/ErrorFallback";
import { useGetPosts } from "../../queries";

export interface iContent {
  title: string;
  postText: string;
  previewText: string;
  date: string;
  id: number;
  username: string;
  coverImage: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface iImageContent {
  id: number;
  name: string;
  path: string;
  type: string;
  PostId?: number;
  GalleryId?: number;
}
interface Props {
  category: string;
}

const ContentShow: React.FC<Props> = (Props) => {
  const history = useNavigate();

  const { data: relatedContents, isLoading: postsLoading } = useGetPosts();

  let contentShowNumbersStep = 5;
  const [contentShowNumbers, setContentShowNumbers] = useState(
    contentShowNumbersStep
  );

  const handleLoadMoreOrLess = () => {
    if (contentShowNumbers === relatedContents.length) {
      setContentShowNumbers(contentShowNumbersStep);
    } else {
      setContentShowNumbers(relatedContents.length);
    }
  };

  const handleReadMore = (id: number) => {
    history(`/${Props.category}/${id}`);
  };

  return (
    <div className="mainPanel">
      <div className="contentShowPanelMain">
        <SmallContentDisplay
          category={Props.category === "posts" ? "posts" : "gallery"}
        />
        <div className="listOfContentsWithImage">
          <div className="listOfContentsTopbar">
            آخرین ها
            <div className="contentShowline"></div>
          </div>
          {postsLoading
            ? Array(contentShowNumbersStep)
                .fill(0)
                .map((_, index) => (
                  <div key={index} className="contentPanel">
                    <div className="contentButtonInfo">
                      <div className="contentContainerMain">
                        <div className="contentDateContainerMain">
                          <div className="ContentAuthorName">
                            <div className="userIcon">
                              <AccountCircleIcon fontSize="small" />
                            </div>
                            <Skeleton
                              variant="text"
                              className="contentDateMain"
                              width={25}
                            />
                          </div>
                          <div className="dateIconContentMain">
                            <AccessTimeIcon fontSize="small" />
                          </div>
                          {/* <div clasName="contentDateMain">{value.date}</div> */}
                          <Skeleton
                            variant="text"
                            className="contentDateMain"
                            width={25}
                          />
                        </div>

                        <Skeleton
                          variant="rectangular"
                          className="contentTitleMain"
                        />

                        <Skeleton
                          variant="rectangular"
                          className="navlink contentTextMain"
                          height="100%"
                          style={{ marginTop: "10px" }}
                        />
                      </div>
                      <div></div>
                    </div>
                    <Skeleton
                      variant="rectangular"
                      className="contentImageContainerMain"
                    />
                  </div>
                ))
            : relatedContents
                ?.slice(0, contentShowNumbers)
                ?.map((value: iContent) => {
                  return (
                    <div key={value.id} className="contentPanel">
                      <div className="contentButtonInfo">
                        <div className="contentContainerMain">
                          <div className="contentDateContainerMain">
                            <div className="ContentAuthorName">
                              <div className="userIcon">
                                <AccountCircleIcon fontSize="small" />
                              </div>
                              <div>ادمین</div>
                            </div>
                            <div className="dateIconContentMain">
                              <AccessTimeIcon fontSize="small" />
                            </div>
                            <div className="contentDateMain">{value.date}</div>
                          </div>
                          <NavLink
                            className="navLink"
                            to={`/${Props.category}/${value.id}`}
                          >
                            <div className="contentTitleMain">
                              {value.title}
                            </div>
                          </NavLink>
                          <p
                            className="contentTextMain"
                            dangerouslySetInnerHTML={{
                              __html: value.previewText,
                            }}
                          />
                        </div>

                        <Button
                          aria-label={`بیشتر بخوانید درباره ${value.title}`}
                          variant="contained"
                          className="contentActionButton"
                          name="contentActionButton"
                          onClick={() => handleReadMore(value.id)}
                        >
                          {" "}
                          بیشتر بخوانید
                        </Button>
                      </div>
                      <div className="contentImageContainerMain">
                        <img
                          src={require(`../../${value.coverImage}`)}
                          alt="logo"
                        />
                      </div>
                    </div>
                  );
                })}
        </div>
        <button className="loadMore" onClick={handleLoadMoreOrLess}>
          {contentShowNumbers === relatedContents?.length
            ? "بارگذاری کمتر"
            : "بارگذاری بیشتر"}
        </button>
      </div>
      <Sidebar category={Props.category === "posts" ? "gallery" : "posts"} />
    </div>
  );
};

export default withErrorBoundary(ContentShow, {
  FallbackComponent: ErrorFallback,
});
